import { FieldsOptions } from '@sim/form';

export interface CardShape {
  localizzazione: string;
  numeroParti: number;
  osservazioni: string;
}

export const CardShapeMeta: FieldsOptions<CardShape> = {
  localizzazione: {},
  numeroParti: {},
  osservazioni: {},
};

